import keyMirror from 'keymirror';

export const addImageModalActionTypes = keyMirror({
	HANDLE_ADD_IMAGE_MODAL: null,

	GET_IMAGES_REQUEST: null,
	GET_IMAGES_SUCCESS: null,
	GET_IMAGES_ERROR: null,

	UPLOAD_IMAGE_REQUEST: null,
	UPLOAD_IMAGE_SUCCESS: null,
	UPLOAD_IMAGE_ERROR: null,

	CLEAR_ADD_IMAGE_MODAL_STATE: null,
});
